export const parseSalesFiltersFromWindowHash = (): {
  periodGranularity: string;
  startDate: string;
} | null => {
  const rawHash = typeof window === 'undefined' ? '' : window.location.hash;
  const hash = rawHash.replace(/^#\/?/, '');
  const match = hash.match(/^venue\/\d+\/sales\/([^/]+)\/([^/]+)/);

  if (!match) {
    return null;
  }

  return {
    periodGranularity: decodeURIComponent(match[1]),
    startDate: decodeURIComponent(match[2]),
  };
};
